import React, { Component } from "react";
import { withFormsy } from "formsy-react";
import { Alert, Button } from "reactstrap";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import { Spinner } from "../Shared";
import { MySelect } from "../Shared/Forms";

import { coreActions } from "./actions/core.actions";

export class CoreIssuers extends Component {
  componentDidMount() {
    this.getCoreIssuers();
  }

  getCoreIssuers = () => {
    this.props.getCoreIssuers();
  };

  render() {
    const { fetching, response, error, name, value, disabled } = this.props;

    const selectedValue =
      response && response.modelList.filter(issuer => issuer.code === value);

    return (
      <div>
        {fetching ? (
          <Alert color="info">
            <Spinner message="Fetching Issuers" />
          </Alert>
        ) : (
          <div>
            <MySelect
              name={name}
              value={selectedValue && selectedValue[0]}
              title="Issuer"
              options={response ? response.modelList : []}
              valueKey="cbnCode"
              disabled={disabled}
              labelKey="name"
              validating={fetching}
              innerRef={c => {
                this.issuerCode = c;
              }}
              isClearable={true}
              required
            />
            {!response && error && (
              <Alert color="danger">
                {error.message}
                <div className="text-reight">
                  <Button color="danger" onClick={this.getCoreIssuers}>
                    Retry
                  </Button>
                </div>
              </Alert>
            )}
          </div>
        )}
      </div>
    );
  }
}

const mapStateToProps = state => {
  const { fetching, fetched, response, error } = state.coreIssuers;
  return {
    fetching,
    fetched,
    response,
    error
  };
};

const mapDispatchToProps = dispatch => {
  return {
    getCoreIssuers: bindActionCreators(coreActions.getCoreIssuers, dispatch)
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withFormsy(CoreIssuers));
